import { Component, OnInit } from '@angular/core';
import { Form } from '@atefhashem/eforms';
import { ActivatedRoute } from '@angular/router';
import { FormTemplateService } from 'app/services/form-template.service';
import { cloneDeep } from 'lodash';
import { loopOnComponents } from 'app/helpers/utils';
import { DataService } from 'app/services/data.service';
import { UserService } from 'app/services/user.service';
import { TeamService } from 'app/services/team.service';
import { ContactService } from 'app/services/contactService';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private formTemplateService: FormTemplateService,
              private dataService: DataService, private userService: UserService, private teamService: TeamService, private contactService: ContactService) { }

  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe((queryParams) => {
      let submissionId: number = +queryParams['submission_id'];
      this.formTemplateService.getSubmissionById(submissionId).subscribe((s) => {
        var that = this;
        //var formioForm = new Form(document.getElementById('form_div'), s.template.schema, { renderMode: 'html', noAlerts: true});
        var schema = cloneDeep(s.template.schema);
        loopOnComponents(schema, (cmp) => {
          cmp.validate = {};
          cmp.calculateValue = '';
        });
        var formioForm = new Form(document.getElementById('form_div'), schema, {
          renderMode: 'html',
          flatten: true,
          noAlerts: true,
          submissionTimezone: s && s.timezone,
          evalContext: {
            getFormQueryExternalOperationObservable: (uniqueName: string, options: any) => {
              return this.formTemplateService.executeFormQueryExternalOperation(s.template_id, uniqueName, options);
            },
            getDataFieldTermsObservable: (indexPattern: string, fieldKey: string, searchFilter: string = '') =>  {
              return this.dataService.getFieldTerms(indexPattern, fieldKey, searchFilter);
            },
            getDataRawSearchObservable: (indexPattern: string, body: any) => {
              return this.dataService.rawSearch(indexPattern, body);
            },
            getDataSQLQueryObservable: (query: string, format: string = 'json') => {
              return this.dataService.sqlQueryResults(query, format);
            },
            /** @note these do not work in external access yet */
            getUsersObservable: () => {
              return this.userService.getAll();
            },
            getTeamsObservable: () => {
              return this.teamService.getAll();
            },
            getContactsObservable: () => {
              return this.contactService.getAll();
            }
          }
        });
        /** @todo this doesn't get fired for PDF forms for some reason */
        formioForm.ready.then((f) => {
            f.submission = { data: s.value };
            setTimeout(() => {
              const form_ready = document.createElement('form_ready');
              document.body.appendChild(form_ready);
            }, 1);
        });

        formioForm.render();      
      });
    });
  }

}
